<template>
	<div class="resource-list">
    <div class="card bg-light mb-3">
      <div class="card-header">Add a {{getDisplayResource}}</div>
      <div class="card-body pb-0">
        <div class="input-group mb-3">
          <input :placeholder="searchPlaceholder" v-model="search_query" type="text" @keyup="search" class="form-control">
          <div class="input-group-append" v-if="search_query">
            <button class="btn btn-outline-secondary" type="button" @click="resetSearchEvent"><fa-icon icon="times-circle"></fa-icon></button>
          </div>
        </div>
        <div class="alert alert-info" role="alert" v-if="search_message">
          {{search_message}}
        </div>
        <div class="search-result">
          <ul class="list list-unstyled">
            <li v-for="item in search_result" @click="addResourceEvent(item.id)"><fa-icon icon="plus" class="clickable btn-add"></fa-icon> {{item.title}}</li>
          </ul>
        </div>
      </div>
    </div>
    <label>Contents</label>
    <div class="alert alert-info" role="alert" v-if="items.length < 1">
      No {{getDisplayResource}}s added yet.
    </div>
		<ul class="list list-unstyled" name="docuOrder">
      <draggable v-model="items" group="docus" :move="checkMove" @start="drag=true" @end="stopMove">
        <li class="item" v-for="item in items" :rel="item.id">
            <fa-icon icon="trash-alt" class="clickable btn-delete" v-on:click="deleteItemEvent(item.id)"></fa-icon> {{item.title}} {{ item.sort_order }}
        </li>
      </draggable>
		</ul>
	</div>
</template>

<script>
import _ from "lodash";
import draggable from 'vuedraggable'
import superagent from 'superagent';
import superagentJsonapify from 'superagent-jsonapify';

superagentJsonapify(superagent);
// const superagent = require('superagent');
const csrftoken = document.head.querySelector('meta[name="csrf-token"]');

export default {

  name: 'Resource',
  props: {
  	api: String,
    resource: String,
    displayResource: String
  },
  components: {
            draggable,
        },
  data() {
    return {
      search_result: [],
      search_query: '',
      search_message: '',
    	items: [],
      drag: false
    };
  },
  methods: {
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    stopMove: function(e) {
      console.log("Inside stopMove");
      console.log(e);
      console.log("====");
      var protocol = location.protocol;
      var apihost = this._props.api;
      if(location.host == "api.naudio.app/")
        protocol = "https:";
      const url = protocol + '//' + location.host + apihost + "/update-sort-order";
      console.log("Api URL: " + url);
      // Get the Collection ID:
      var collection_id = this._props.api.split("/")[4];
      var sort_order = [];
      var sort_position = 0;
      var docu_elements = document.getElementsByName("docuOrder")[0].children[0].children;
      docu_elements.forEach((docu_element) => {
        console.log(docu_element);
        sort_order[sort_position] = docu_element.attributes[1].nodeValue;
        sort_position++;
      });
      // console.log(this.items);
      this.items.forEach((item) => console.log(item.pivot));
      window.console.log("API: " + this._props.api);
      window.console.log("Resource: " + this._props.resource);
      window.console.log("URL: " + url);
      window.console.log(axios.defaults.baseURL);
      // Attempt to bypass axios with superagent
      superagent.post(url)
      .send({sort_order: sort_order, collection_id: collection_id})
      .set('X-CSRF-TOKEN',csrftoken.content)
      .set('Accept','application/json')
      .then(this.updateItems).catch((err) => { 
        console.log("Error posting new sort order!");
        console.error(err); 
      });
      // .end((err,res) => { console.log("Sending request, error: "); console.log(err); });
      // var axiosInstance = axios.create({ baseURL: location.protocol + '//' + location.host });
      // axiosInstance.post(url,{ sort_order: sort_order, collection_id: collection_id}).then(this.updateItems).catch((err) => { console.error(err); });
    },
    // Remove entry form item store
    deleteItemEvent: function(id) {
      const url = `${this._props.api}/${this._props.resource}/${id}`;
      // var axiosInstance = axios.create({ baseURL: location.protocol + '//' + location.host });

      if (confirm('Are you sure you want to delete this?')) {
        superagent.delete(url)
          .set('X-CSRF-TOKEN',csrftoken.content)
          .then(this.updateItems)
          .catch((err) => {
            console.error(err);
          });

        /*
        axiosInstance.delete(url)
          .then(this.updateItems)
          .catch((err) => {
            console.error(err);
          });
        */
      }
    },

    // Clear search field
    resetSearchEvent: function(e) {
      this.search_query = '';
      this.search_message = '';
      this.search_result = [];
    },

    // Add resource to list
    addResourceEvent: function(id) {
      const url = `${this._props.api}/${this._props.resource}/${id}`;
      superagent.put(url)
          .set('X-CSRF-TOKEN',csrftoken.content)
          .then((result) => {
            this.updateItems(result);
            this.resetSearchEvent();
           })
          .catch((err) => {
            console.error(err);
          });
      /*
      var axiosInstance = axios.create({ baseURL: location.protocol + '//' + location.host });
      axiosInstance.put(url)
        .then((result) => {
          this.updateItems(result);
          this.resetSearchEvent();
        })
        .catch((err) => {
          console.error(err.message);
        });
      */
    },

    // Refresh item store
  	refreshResource: function() {
      superagent.get(this._props.api)
          .set('X-CSRF-TOKEN',csrftoken.content)
          .then(this.updateItems)
          .catch((err) => {
            console.error(err);
          });
      /*
      var axiosInstance = axios.create({ baseURL: location.protocol + '//' + location.host });
      axiosInstance.get(this._props.api)
        .then(this.updateItems)
        .catch((err) => {
          console.error(err.message);
        });
        */
  	},

    // Perform sorting of the request data, and update item store
    updateItems: function(response) {
      // console.log("Update Items has been called");
      // console.log(response);
      // Modify response to be axios AND superagent compatible
      if(typeof response.data !== 'undefined')
        response = response.data;
      else {
        response = JSON.parse(response.text);
      }
      var collection_id = this._props.api.split("/")[4];
      var modified_elements = [];
      // Modified this to be just response as with superagent that's what we'll have, axios had response.data, but the above fix on line 147ish solves the incompatability
      response.forEach((element) => {
          // console.log("We are in the updateItems thingamajigger");
          var handledSortOrder = false;
          element.collection_sort_orders.forEach((sort_order) => {
              if(sort_order.collection_id == collection_id) {
                if(isNaN(sort_order.sort_order)){
                  element.sort_order = modified_elements.length + 1; 
                } else {
                  element.sort_order = sort_order.sort_order;
                }
                modified_elements.push(element);
                handledSortOrder = true;
              }
          });
          if(!handledSortOrder) {
            // This happens if the given story does not have a sort order associated with it.
            element.sort_order = modified_elements.length + 1;
            modified_elements.push(element);
          }
          // console.log(element);
      });
      // this.items = _.sortBy(response.data, 'title');
      this.items = _.sortBy(modified_elements, 'sort_order');
    },

    // Search results
    search: _.debounce(function(e) {
      // Reset if search-box is empty
      if (e.target.value.length < 1) {
        this.resetSearchEvent();
        return;
      }

      // Query backend
      const url = `/admin/api/search/${this._props.resource}`;
      superagent.post(url)
      .send({ query: e.target.value })
      .set('X-CSRF-TOKEN',csrftoken.content)
      .then((result) => {
        var data = result.body;
        if(data.constructor === Array) {
          this.search_message = 'Type a few more characters, please ...';
        } else if (data.result.length < 1) {
          this.search_message = `No ${this.getDisplayResource} matches your query.`;
        } else {
          this.search_message = '';
        }
        this.search_result = data.result;
      }).catch((err) => { console.log(err.message)});
      /*
      var axiosInstance = axios.create({ baseURL: location.protocol + '//' + location.host });
      axiosInstance.post(url, { query: e.target.value }).then((result) => {
        if(result.data.constructor === Array) {
          this.search_message = 'Type a few more characters, please ...';
        } else if (result.data.result.length < 1) {
          this.search_message = `No ${this.getDisplayResource} matches your query.`;
        } else {
          this.search_message = '';
        }

        this.search_result = result.data.result;
      }).catch((err) => {
        console.error(err.message);
      });
      */
    }, 200),
  },
  computed: {
    searchPlaceholder: function() {
      return `Find ${this.getDisplayResource}`;
    },
    getDisplayResource: function() {
      return this.displayResource || 'snick';
    }
  },
  mounted() {
    this.refreshResource();
  }
};
</script>

<style lang="css" scoped>
  svg.btn-delete, svg.btn-add {
    margin: 0 0.5rem;
  }
  .list li.item {
    padding-top: 3px;
    background-color: #e2f0fb;
    border-bottom: 1px dashed white;
    border-radius: 5px;
  }
</style>
